import classNames from 'classnames';
import * as React from 'react';

import { SwitchToOldInterfaceLinkContainer } from '../../containers/SwitchToOldInterfaceLinkContainer/SwitchToOldInterfaceLinkContainer';
import { Bem } from '../../service/Bem/Bem';

import './ScreenErrorMessage.css';

export interface ScreenErrorMessageProps {
    header: React.ReactNode;
    text?: React.ReactNode;
    cls?: string;
    isVisible?: boolean;
    showLinkSwitchOnOldInterface?: boolean;
}

export class ScreenErrorMessage extends React.PureComponent<
    ScreenErrorMessageProps
> {
    render() {
        const {
            header,
            text,
            cls,
            isVisible = true,
            showLinkSwitchOnOldInterface
        } = this.props;
        let textContent;

        if (!isVisible) {
            return null;
        }

        if (text) {
            textContent = (
                <div className={Bem.cls('screen-error-message', 'text')}>
                    {text}
                </div>
            );
        }

        return (
            <div className={classNames(cls, Bem.cls('screen-error-message'))}>
                <div className={Bem.cls('screen-error-message', 'header')}>
                    {header}
                </div>

                {textContent}

                {showLinkSwitchOnOldInterface && (
                    <div
                        className={Bem.cls('screen-error-message', 'solution')}
                    >
                        <SwitchToOldInterfaceLinkContainer key="switch-to-old-interface-link" />
                    </div>
                )}
            </div>
        );
    }
}
